import {Loan} from '../../model/loan.model';

export abstract class LoanListFilter {
    abstract onFilterApplied(loan: Loan): boolean;
}
